var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DOMUtils } from "../../services";
import { Events } from "../../interfaces";
import { Ruler } from "./ruler";
var StackedRuler = /** @class */ (function (_super) {
    __extends(StackedRuler, _super);
    function StackedRuler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackedRuler.prototype.formatTooltipData = function (tooltipData) {
        return tooltipData.reverse();
    };
    StackedRuler.prototype.hideRuler = function () {
        var svg = this.parent;
        var ruler = DOMUtils.appendOrSelect(svg, "g.ruler");
        this.services.events.dispatchEvent(Events.Tooltip.HIDE);
        ruler.attr("opacity", 0);
    };
    return StackedRuler;
}(Ruler));
export { StackedRuler };
//# sourceMappingURL=../../../src/components/axes/ruler-stacked.js.map